const initialUsersState = {
  users: undefined,
};

export default initialUsersState;
